import React, { useCallback } from 'react';

import cn from 'classnames';
import { useSelector } from 'react-redux';

import { Switch } from '../../../components';
import { i18n } from '../../../helpers/i18n';
import { countMetrika } from '../../../helpers/metrika';
import { useActions } from '../../../hooks';
import { selectHideParticipantsVideo, toggleHideParticipantsVideoAction } from '../../settings';
import css from './styles.css';

export const HideParticipantsVideoSwitch = () => {
    const actions = useActions({ toggleHideParticipantsVideoAction });

    const hideParticipantsVideo = useSelector(selectHideParticipantsVideo);

    const onChange = useCallback(() => {
        const newValue = !hideParticipantsVideo;
        countMetrika('meeting_screen', 'turn_incoming_video_click', newValue === true ? 'off' : 'on');
        actions.toggleHideParticipantsVideoAction(newValue);
    }, [actions, hideParticipantsVideo]);

    return (
        <Switch
            labelBefore={
                <span>
                    {i18n('settings', 'hide-participants-video')}
                    <span className={css.switchDescription}>
                        {i18n('settings', 'hide-participants-video-description')}
                    </span>
                </span>
            }
            className={cn(css.switch, css.switchSpace)}
            checked={hideParticipantsVideo}
            onChange={onChange}
            size="md"
            stretch
            shrink
        />
    );
};
